var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"tableProps":_vm.tableProps,"tableEvents":_vm.tableEvents,"filters":_vm.filters,"updateFilter":_vm.updateFilter,"searchValue":_vm.searchValue,"updateSearch":_vm.updateSearch,"searchConfig":_vm.searchConfig})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }